import React, { PureComponent, Component } from 'react';
import CheckDefecto from '../../../../Common/Components/CheckDefecto'
import SelectWithLabel from '../../../../Common/Components/SelectWithLabel'
import Diaria from './Diaria'
import Semanal from './Semanal'
import Mensual from './Mensual'
import Cierre from './Cierre'
import EntreDias from './EntreDias'


class Periodicidad extends Component {
    constructor(props) {
        super(props)

    }

    render() {

        const { data, selectRadio, changeInput, setCheck, seleccionarCombo} = this.props;

        return (
            <div className="row top-separator-xs">
                <div style={{marginLeft:"1px"}} className="row top-separator-xs">
                    <div className="col-xs-5">
                        <label className="label-primary">{"Periodicidad"}</label>                        
                    </div>
                </div> 

                    <Diaria proceso={data.proceso} calendario={data.calendario} selectRadio={selectRadio} changeInput={changeInput} setCheck={setCheck} />
                    <Semanal data={data} selectRadio={selectRadio} changeInput={changeInput} setCheck={setCheck} />
                    <Mensual data={data} selectRadio={selectRadio} changeInput={changeInput} setCheck={setCheck} />
                    <Cierre data={data} selectRadio={selectRadio} changeInput={changeInput} setCheck={setCheck} seleccionarCombo={seleccionarCombo} />
                    <EntreDias data={data}  selectRadio={selectRadio} changeInput={changeInput} setCheck={setCheck}  />
                 
                </div>
        
        )
    };
}

export default Periodicidad;